export default __webpack_public_path__ + "static/Sun Chaser logo v1.2-eb74f8935e8f0afe050e32c8bd3211ca.svg";